export default __webpack_public_path__ + "static/media/fuhr2.317eb5f2.svg";